import React, { useState } from 'react'
import Consulta from './Types/consulta'
import Cadastro from './Types/cadastro'
import TabNavigation from '../General/TabNavigation'

const Anexos = () => {
  const [activeTab, setActiveTab] = useState('consulta')

  // Função para ser passada ao Cadastro
  const handleTabChange = (tabKey) => {
    setActiveTab(tabKey)
  }

  const tabs = [
    {
      key: 'consulta',
      label: 'Consulta',
      icon: 'folder',
      content: <Consulta />
    },
    {
      key: 'cadastro',
      label: 'Cadastro',
      icon: 'config',
      content: <Cadastro onTabChange={handleTabChange} />
    }
  ]

  return (
    <div className='w-full min-h-full'>
      <TabNavigation
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        variant="default"
      />
    </div>
  )
}

export default Anexos
